import axios from "axios";
import Swal from "sweetalert2";
import moment from "jalali-moment";
import axiosRetry from 'axios-retry';


function getAxiosConfig() {
  return {
    baseURL: process.env.VUE_APP_BASE_URL,
    credentials: false,
    debug: false,
    https: true,
    host: '',
    prefix: '',
    port: '',
    headers: {
      common: {
        'Access-Control-Allow-Origin': '*', 'Cache-Control': 'no-cache', 'crossDomain': true,
      }
    },
  };
}

function createAxiosInstance(config) {
  const http = axios.create(config);
  handleRequest(http);
  handleResponse(http);
  // axiosRetry(http, {
  //   retries: 1,
  //   retryCondition: (error) => {
  //     const {status = 500} = error.response;
  //     return (error.config.url !== '/Auth/refresh-token' || status === 401)
  //   }
  // });
  return http;
}

function handleRequest(axiosInstance) {
  axiosInstance.interceptors.request.use(onSendRequest, onRejectRequest);
}

function handleResponse(axiosInstance) {
  axiosInstance.interceptors.response.use(onSuccessResponse, (error) => onErrorResponse(error));
}

async function onSendRequest(config) {
  setRequestAuthToken(config)
  return config;
}

function setRequestAuthToken(config) {
  const urlsNeedTempToken = ['/Auth/login/token', '/Authenticators/email', '/Authenticators/sms', '/Authenticators/active',]

  let token = localStorage.getItem('token');

  if (urlsNeedTempToken.includes(config.url)) {
    token = localStorage.getItem('tempToken');
  }
  config.headers.Authorization = `Bearer ${token}`;
}

function onRejectRequest(error) {
  return Promise.reject(error);
}

async function onSuccessResponse(response) {
  return response;
}

function onErrorResponse(error) {

  // const errorResponse = error.response.data || {
  //   message: 'خطای رخ داده است.',
  // }

  //const retryCount = error.response.config['axios-retry']['retryCount']

    const {status = 500} = error.response || {};
    switch (status) {
      case 401: {
        if (error.config.url !== '/Auth/refresh-token') {
          Swal.fire({
            text: "ابتدا وارد حساب کاربری خود شوید.",
            icon: "error",
            confirmButtonText: "باشه",
          });
          window.location.href = "/login"
          localStorage.clear()
        }
        break;
      }
      case 403: {
        // message.warning('شما دسترسی ندارید')
        break;
      }
      case 429: {
        // message.warning('لطفا چند لحظه صبر کنید ، بیش از حد تلاش کردید.')
        break;
      }
      default: {
        //message.error(errorResponse)
      }
    }



  return Promise.reject(error);
}


const http = createAxiosInstance(getAxiosConfig());

export default {
  get: http.get, post: http.post, put: http.put, patch: http.patch, delete: http.delete,
};
